import React, { useEffect, useState } from "react";
import { useAuth } from "../../Context/AuthContext";
import { ApiEndpoint, ShortUrlEndpoint } from "../../utils/ApiEndpoint";

import { format } from "date-fns";

import { Stack } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
import * as FiIcons from "react-icons/fi";
import * as HiIcons from "react-icons/hi2";
import * as AiIcons from "react-icons/ai";

import ChartBitly from "../../components/widgets/widgetChartBitly";

import BtnExportToExcell from "../../utils/BtnExportToExcell";
import { httpClient } from "../../utils/HttpClient";
import ShortLinkInfo from "./_ShortLinkInfo";
import PropTypes from "prop-types";

const ShortLinkDetail = ({
  ShortLink,
  ShortLinkName,
  OriginalLink,
  ShortLinkFull,
}) => {
  const Auth = useAuth();
  const userData = Auth.getSessionData();

  const [cliksInfo, setCliksInfo] = useState(null);
  const [uniqueCliksInfo, setUniqueCliksInfo] = useState(null);
  const [totalClicks, setTotalClicks] = useState(null);
  const [bestDay, setBestDay] = useState(null);

  function GetToken() {
    httpClient(
      "GET",
      ApiEndpoint + "partnersettings/" + userData.uid_partner,
      {},
      userData.token
    ).then(function (response) {
      console.log(response.data);
      GetInfoUrl(response.data.tokenbitly);
    });
  }

  // function GetInfoUrlBitly(state) {
  //   const config = {
  //     headers: {
  //       Authorization: "Bearer " + state,
  //       "Content-Type": "application/json",
  //     },
  //   };
  //   axios
  //     .get(
  //       "https://api-ssl.bitly.com/v4/bitlinks/" +
  //         ShortLink +
  //         "/clicks?unit=day&units=-1&size=10",
  //       config
  //     )
  //     .then(function (response) {
  //       var LinkData = response.data.link_clicks;
  //       setCliksInfo(LinkData);

  //       var BestDate = LinkData.sort((a, b) => b.clicks - a.clicks)[0].date;
  //       setBestDay(BestDate.substring(0, 10));
  //     })
  //     .catch(function (error) {
  //       setMessageNotification("Ha ocurrido un error");
  //       setNotificationType("warning");
  //       setShow(true);
  //       console.log(error);
  //     });

  //   axios
  //     .get(
  //       "https://api-ssl.bitly.com/v4/bitlinks/" +
  //         ShortLink +
  //         "/clicks/summary?unit=day&units=-1&size=10",
  //       config
  //     )
  //     .then(function (response) {
  //       var LinkDataTotal = response.data.total_clicks;
  //       setTotalClicks(LinkDataTotal);
  //     })
  //     .catch(function (error) {
  //       setMessageNotification("Ha ocurrido un error");
  //       setNotificationType("warning");
  //       setShow(true);
  //       console.log(error);
  //     });
  // }

  function GetInfoUrl() {
    httpClient(
      "GET",
      ShortUrlEndpoint + "reports/bydate/" + ShortLink,
      {},
      userData.token
    )
      .then((response) => {
        var LinkData = response.data;
        setCliksInfo(LinkData);
        var totalCls = LinkData.data.reduce(
          (partialSum, item) => partialSum + Number(item.clicks),
          0
        );
        var totalUniCls = LinkData.data.reduce(
          (partialSum, item) => partialSum + Number(item.unique),
          0
        );
        setTotalClicks(totalCls);
        setUniqueCliksInfo(totalUniCls);
        var BestDate = LinkData.data.sort((a, b) => b.clicks - a.clicks)[0]
          .date;
        console.log(BestDate);
        var NewDate = new Date(BestDate.replace(/-/g, "/"));
        setBestDay(format(new Date(NewDate), "d MMMM"));
        //setBestDay(format(new Date(BestDate), "d MMMM"));
        //format(new Date(bestDay), "d MMMM");
      })
      .catch(function (error) {
        // setMessageNotification("Ha ocurrido un error");
        // setNotificationType("warning");
        // setShow(true);
        console.log(error);
      });
  }
  useEffect(() => {
    GetToken();
  }, []);

  return (
    <>
      <Stack direction="horizontal" className="titleShortUrl" gap={0}>
        <b> {ShortLinkName} </b>
        <div className="ms-auto">
          {cliksInfo && (
            <BtnExportToExcell
              dataReport={cliksInfo.data}
              fileName="Url_Report"
            ></BtnExportToExcell>
          )}{" "}
          <FiIcons.FiRefreshCw onClick={() => GetInfoUrl()} />
        </div>
      </Stack>

      <div className="borderData">
        <p>
          <b>Url corta:</b> {ShortLinkFull}{" "}
        </p>
        <p>
          <b>Url original:</b>{" "}
          {OriginalLink ? OriginalLink.substring(0, 40) : null}
          ...{" "}
        </p>
      </div>
      <Row>
        <Col xs={6} sm={6} md={4} lg={4} xl={4}>
          <div className="DbDetails4">
            <Stack direction="horizontal" gap={2}>
              <HiIcons.HiOutlineCursorArrowRipple />
              <div className="ms-auto">
                <p>{totalClicks}</p>
              </div>
            </Stack>
            <div className="details">Total de clicks</div>
          </div>
        </Col>
        <Col xs={6} sm={6} md={4} lg={4} xl={4}>
          <div className="DbDetails5">
            <Stack direction="horizontal" gap={2}>
              <HiIcons.HiOutlineCursorArrowRays />
              <div className="ms-auto">
                <p> {uniqueCliksInfo}</p>
              </div>
            </Stack>
            <div className="details">Clicks Únicos</div>
          </div>
        </Col>
        <Col xs={6} sm={6} md={4} lg={4} xl={4}>
          <div className="DbDetails1">
            <Stack direction="horizontal" gap={2}>
              <AiIcons.AiOutlineLineChart />
              <div className="ms-auto">
                <p>{bestDay}</p>
              </div>
            </Stack>
            <div className="details">Día con más clicks</div>
          </div>
        </Col>
      </Row>

      <div className="Status">
        <Stack direction="horizontal" gap={2}>
          <h6>Clicks por día</h6>
        </Stack>
        {cliksInfo && <ChartBitly LinkData={cliksInfo.data}></ChartBitly>}
      </div>

      <ShortLinkInfo ShortLink={ShortLink}></ShortLinkInfo>
    </>
  );
};
ShortLinkDetail.propTypes = {
  ShortLink: PropTypes.number.isRequired,
  ShortLinkName: PropTypes.string.isRequired,
  ShortLinkFull: PropTypes.string.isRequired,
  OriginalLink: PropTypes.string.isRequired,
  handleShow: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};
export default ShortLinkDetail;
